import React from "react";
import { Grid, Dialog, Button } from "../../../../../";
import { Typography, Divider, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import TodayIcon from "@material-ui/icons/Today";
import PersonIcon from "@material-ui/icons/Person";
import selects from "../../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    mt8: {
      marginTop: "8px"
    },
    textIconHorizontal: {
      marginTop: "8px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    },
    chipGroup: {
      borderRadius: "6px",
      background: theme.palette.background.paper,
      margin: "4px",
      border: "1px solid ".concat(theme.palette.text.primary)
    },
    attended: {
      border: "1px solid ".concat(theme.palette.primary.main),
      color: theme.palette.primary.main
    },
    not_attended: {
      border: "1px solid ".concat(theme.palette.secondary.main),
      color: theme.palette.secondary.main
    },
    infoContainer: {
      display: "flex",
      "flex-direction": "column",
      "align-items": "center"
    },
    infoRowContainer: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-between",
      width: "100%",
      "padding-top": "5px"
    },
    w50: {
      width: "50%"
    },
    mr30: {
      marginRight: "30px"
    }
  };
});

var MobileDialogCampusGroupAttendance = function MobileDialogCampusGroupAttendance(props) {
  // console.log("props attendance", props);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.infoContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.infoRowContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, props.data ? props.data.name || "..." : "..."), /*#__PURE__*/React.createElement(Chip, {
    label: props.data ? props.data.group ? props.data.group.name > 12 ? props.data.group.name.substring(0, 10) + "..." : props.data.group.name || "..." : "..." : "...",
    className: [classes.chipGroup, classes.w50].join(" ")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.infoRowContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    align: "center"
  }, props.data ? props.data.date : ""), props.data && props.data.status && /*#__PURE__*/React.createElement(Chip, {
    label: props.translation ? props.translation.checkInStatus[props.data.status] : selects.checkInStatus[props.data.status] || "...",
    className: [classes.chipGroup, props.data.status === "attended" ? classes.attended : classes.not_attended].join(" ")
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.checkin || "Check in" : "Check in" : "Check in")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, props.data ? props.data.checkin ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.textIconHorizontal
  }, /*#__PURE__*/React.createElement(TodayIcon, {
    className: classes.mr30
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data.checkin.date ? moment(props.data.checkin.date).format("DD/MM/YYYY HH:mm") || "Invalid date" : "Invalid date")), /*#__PURE__*/React.createElement("div", {
    className: classes.textIconHorizontal
  }, /*#__PURE__*/React.createElement(PersonIcon, {
    className: classes.mr30
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data.checkin.type === "group_change" ? props.translation ? props.translation.texts ? props.translation.texts.group_change || "Group change" : "Group change" : "Group change" : props.data.checkin.responsible ? props.data.checkin.responsible.name || "-" : "-"))) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.translation ? props.translation.texts ? props.translation.texts.checkin_empty || "Not done yet" : "Not done yet" : "Not done yet") : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.translation ? props.translation.texts ? props.translation.texts.checkin_empty || "Not done yet" : "Not done yet" : "Not done yet")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.texts ? props.translation.texts.checkout || "Check out" : "Check out" : "Check out")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, props.data ? props.data.checkout ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.textIconHorizontal
  }, /*#__PURE__*/React.createElement(TodayIcon, {
    className: classes.mr30
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data.checkout.date ? moment(props.data.checkout.date).format("DD/MM/YYYY HH:mm") || "Invalid date" : "Invalid date")), /*#__PURE__*/React.createElement("div", {
    className: classes.textIconHorizontal
  }, /*#__PURE__*/React.createElement(PersonIcon, {
    className: classes.mr30
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.data.checkout.type === "group_change" ? props.translation ? props.translation.texts ? props.translation.texts.group_change || "Group change" : "Group change" : "Group change" : props.data.checkout.responsible ? props.data.checkout.responsible.name || "-" : "-"))) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.translation ? props.translation.texts ? props.translation.texts.checkout_empty || "Not done yet" : "Not done yet" : "Not done yet") : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, props.translation ? props.translation.texts ? props.translation.texts.checkout_empty || "Not done yet" : "Not done yet" : "Not done yet"))));
};

export { MobileDialogCampusGroupAttendance };